import {z} from 'zod';

export const CohortTypeSchema = z.enum(['segment', 'list']);
export type CohortType = z.infer<typeof CohortTypeSchema>;
